import { ActionTypeKeys, ActionTypes } from 'embed/actions'
import { Config as ConfigType } from '@evenfinancial/even-ts-static'
import { DeepReadonly } from 'utility-types'

type Config = DeepReadonly<ConfigType>

export const initialConfigState: Config = {}

const reducer = (state: Config = initialConfigState, action: ActionTypes) => {
  switch (action.type) {
    case ActionTypeKeys.LOAD_CONFIG_SUCCESS:
      return {
        ...state,
        ...action.config,
        clientTags: {
          ...(action.config.clientTags ?? {}),
          system: ['embed'],
        },
      }
    case ActionTypeKeys.UPDATE_CONFIG_STEP:
      return {
        ...state,
        step: action.step,
      }
    default:
      return state
  }
}

export default reducer
